import { Box } from '@mui/material';
import { Tour } from '@styled-icons/material/Tour';
import ChainMapping from 'FeatureModules/ComponentChain/Components/ChainMapping';
import ChainTasksDetails from 'FeatureModules/ComponentChain/Components/ChainTasksDetails';
import CreateChainPlaceholder from 'FeatureModules/ComponentChain/Components/CreateChainPlaceholder';
import Loader from 'Components/Forms/Loader';
import useSupplyChainMapping from 'FeatureModules/SupplyChain/hooks/useSupplyChainMapping';
import { STEP_BY_STEP_LIST_HEIGHT } from 'FeatureModules/ComponentChain/utils/chainMapping';
import { ThemeButton } from 'DesignSystem';
import React, { FC } from 'react';
import ErrorState from 'Components/ErrorState';
import PageContainer from 'Components/PageContainer';
import PageTitle from 'Components/PageTitle';

const SupplyChainMapping: FC = () => {
  const {
    supplyChain,
    queryLoading,
    mutationLoading,
    error,
    expandList,
    handleChainMappingAction,
    handleCreateNewChainClick,
    handleCreateByCopyChainClick,
    handleExpandList,
    handleClickOnboardingTour,
  } = useSupplyChainMapping();

  if (queryLoading || !supplyChain) {
    return <Loader />;
  }
  if (error || !supplyChain) {
    return <ErrorState />;
  }

  return (
    <PageContainer>
      <Box display="flex" alignItems="end">
        <Box width="100%">
          <PageTitle
            title="Supply chain mapping"
            enableAutoGoBackHistoryButton
            titleExtension={supplyChain.title}
            goBackLabel="Supply chain overview"
            goBackUrl={`/supply-chains/active/${supplyChain.productId}/${supplyChain.id}}`}
          />
        </Box>
        <ThemeButton
          color="WHITE"
          data-testid="restart-tour-button"
          size="small"
          onClick={handleClickOnboardingTour}
          startIcon={<Tour size={16} color="black" />}
        >
          Restart guided tour
        </ThemeButton>
      </Box>
      <Box position="relative" mt={2}>
        <ChainTasksDetails
          hideEdit
          expanded={expandList}
          height={STEP_BY_STEP_LIST_HEIGHT}
          title={supplyChain.title}
          image={supplyChain.image}
          isSupplyChain
          chainTasksDetails={supplyChain.chainTasksDetails}
          onExpand={handleExpandList}
        />
      </Box>
      {mutationLoading && <Loader overlayOpacity />}
      <Box height="80%" mt={`${STEP_BY_STEP_LIST_HEIGHT + 35}px`}>
        {!supplyChain.mappingInitialised ? (
          <CreateChainPlaceholder
            isCopyButtonVisible={false} // Disabled until the proper duplication feature is implemented in the backend
            startFromScratchButtonLabel="Start empty chain"
            onStartFromSketchClick={handleCreateNewChainClick}
            onCopyChainClick={handleCreateByCopyChainClick}
          />
        ) : (
          <ChainMapping
            viewMode="default"
            chainMapping={supplyChain}
            onActionClick={handleChainMappingAction}
          />
        )}
      </Box>
    </PageContainer>
  );
};

export default SupplyChainMapping;
